import type { SignalFilters, SignalId } from "app/pages/sales-intelligence/domain/signals/types/signal";

import type SignalsManagementViewModel from "../models/view/signals-management/SignalsManagementViewModel";
import type UISignal from "../models/view/UISignal";

export function findUISignalById(
    viewModel: Readonly<SignalsManagementViewModel>,
    signalId: SignalId,
): Readonly<UISignal<SignalFilters>> | null {
    for (const { type } of viewModel.signalTypes) {
        const signal = viewModel.getUISignalsOfType(type).find((uiSignal) => uiSignal.id === signalId);

        if (signal) {
            return signal;
        }
    }

    return null;
}
